(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("categoriesAndBandsManage", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningItems/categoriesAndBands/categoriesAndBandsManageView.html",
            controller: ["categoryResource", "bandResource", "$document", "$q", "$scope", "$translate", "$anchorScroll", "$timeout", "messageService", "$uibModal", "$localStorage", "_", CategoriesAndBandsManageCtrl],
            controllerAs: "vm"
        };
        function CategoriesAndBandsManageCtrl(categoryResource, bandResource, $document, $q, $scope, $translate, $anchorScroll, $timeout, messageService, $uibModal, $localStorage, _) {
            var vm = this;
            vm.categories = [];
            vm.translationEnabled = $localStorage.tenantSettings.enabledLocalizations.length > 1;
            vm.reorderMode = false;
            vm.reoderType = "";
            var currentLanguageCulture = $translate.use();
            loadCategories();
            ///////////////////////////////////////////////////////
            function loadCategories() {
                categoryResource.get(function (result) {
                    vm.categories = result.categories;
                    vm.categories.sort(function (a, b) { return a.order - b.order; });
                    for (var category in vm.categories) {
                        if (vm.categories.hasOwnProperty(category)) {
                            vm.categories[category].bands.sort(function (a, b) { return a.order - b.order; });
                            for (var band in vm.categories[category].bands) {
                                if (vm.categories.hasOwnProperty(band)) {
                                    vm.categories[category].bands[band].learningPaths.sort(function (a, b) { return a.order - b.order; });
                                }
                            }
                        }
                    }
                });
            }
            vm.saveCategory = function (newValue, object) {
                var saveDeferred = $q.defer();
                if (!newValue || newValue.trim() === "") {
                    saveDeferred.reject({ required: true });
                }
                else {
                    categoryResource.getIsNameAvailable({
                        name: newValue,
                        languageCulture: currentLanguageCulture
                    }, function (result) {
                        if (!result.value) {
                            saveDeferred.reject({ uniqueName: true });
                        }
                        else {
                            if (object === undefined) { // Adding Category
                                var category = {
                                    name: newValue
                                };
                                categoryResource.save(category, function (result) {
                                    vm.categories.push(result);
                                    saveDeferred.resolve(true);
                                    $timeout(function () {
                                        $anchorScroll(newValue);
                                    });
                                }, function (error) {
                                    messageService.error("common.genericError");
                                    saveDeferred.reject({ exitEditMode: true, error: error });
                                });
                            }
                            else { //Editing Category
                                categoryResource.save(object, function (result) {
                                    object.rowVersion = result.rowVersion;
                                    saveDeferred.resolve(true);
                                }, function (error) {
                                    messageService.error("common.genericError");
                                    saveDeferred.reject({ exitEditMode: true, error: error });
                                });
                            }
                        }
                    }, function (error) {
                        messageService.error("common.genericError");
                        saveDeferred.reject({ exitEditMode: true, error: error });
                    });
                }
                return saveDeferred.promise;
            };
            vm.saveBand = function (newValue, object) {
                var saveBandDeferred = $q.defer();
                if (!newValue || newValue.trim() === "") {
                    saveBandDeferred.reject({
                        required: true
                    });
                }
                else {
                    if (object !== undefined && object != null && object.category !== undefined) {
                        var category = object.category;
                        if (object.band === undefined) {
                            var band = {
                                name: newValue,
                                categoryId: category.id,
                                categoryNumber: category.number
                            };
                            bandResource.save(band, function (result) {
                                category.bands.push((result));
                                messageService.success("learningItems.manageCategoriesAndBands.addBandToCategory");
                                saveBandDeferred.resolve(result);
                            }, function (error) {
                                messageService.error("common.genericError");
                                saveBandDeferred.reject({ exitEditMode: true, error: error });
                            });
                        }
                        else {
                            bandResource.save(object.band, function (result) {
                                object.band.rowVersion = result.rowVersion;
                                saveBandDeferred.resolve(result);
                            }, function (error) {
                                messageService.error("common.genericError");
                                saveBandDeferred.reject({ exitEditMode: true, error: error });
                            });
                        }
                    }
                    else {
                        messageService.error("common.genericError");
                        saveBandDeferred.reject({ exitEditMode: true });
                    }
                }
                return saveBandDeferred.promise;
            };
            vm.checkSameName = function (list, name) {
                return _.where(list, { name: name }).length > 1;
            };
            vm.addPath = function (category, band) {
                var modalInstance = $uibModal.open({
                    templateUrl: "app/learningItems/categoriesAndBands/modals/addPathsModalView.html",
                    controller: "AddPathsModalCtrl as vm"
                });
                modalInstance.result.then(function (listOfPaths) {
                    if (band === undefined) {
                        var newBandName = getNextName(category.bands, category.name, 100);
                        vm.saveBand(newBandName, { category: category }).then(function (result) {
                            vm.savePaths(listOfPaths, result);
                        });
                    }
                    else {
                        vm.savePaths(listOfPaths, band);
                    }
                }).catch(angular.noop);
            };
            vm.savePaths = function (listOfPaths, band) {
                if (!listOfPaths || listOfPaths.length === 0)
                    return;
                var selectedPaths = [];
                for (var idx in listOfPaths) {
                    if (listOfPaths.hasOwnProperty(idx)) {
                        var path = listOfPaths[idx];
                        path.bandId = band.id;
                        path.bandNumber = band.number;
                        selectedPaths.push(path);
                    }
                }
                bandResource.addLearningPaths({ categoryNumber: band.categoryNumber, number: band.number }, selectedPaths, function (result) {
                    band.learningPaths = _.union(band.learningPaths, result);
                }, function () {
                    messageService.error("common.genericError");
                });
            };
            vm.translateCategory = function (category) {
                var modalInstance = $uibModal.open({
                    templateUrl: "app/learningItems/categoriesAndBands/modals/TranslateCategoryModalView.html",
                    controller: "TranslateCategoryModalCtrl as vm",
                    resolve: {
                        category: category
                    }
                });
                modalInstance.result.then(function (result) {
                    var item = _.find(result.categoryLocalizations, function (item) {
                        return item.localizationId.toString() === $localStorage.currentLocalizationId.toString(); //sometimes its an int, sometimes a string ??
                    });
                    category.name = item.name;
                }).catch(angular.noop);
            };
            vm.translateBand = function (category, band) {
                var modalInstance = $uibModal.open({
                    templateUrl: "app/learningItems/categoriesAndBands/modals/translateBandModalView.html",
                    controller: "TranslateBandModalCtrl as vm",
                    resolve: {
                        category: category,
                        band: band
                    }
                });
                modalInstance.result.then(function (result) {
                    var item = _.find(result.bandLocalizations, function (item) {
                        return item.localizationId.toString() === $localStorage.currentLocalizationId.toString(); //sometimes its an int, sometimes a string ??
                    });
                    band.name = item.name;
                }).catch(angular.noop);
            };
            vm.removePath = function (band, path) {
                var confirmationModal = $uibModal.open({
                    templateUrl: "removePathConfirmation.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                confirmationModal.result.then(function () {
                    bandResource.removeLearningPath({ categoryNumber: band.categoryNumber, number: band.number }, path, function () {
                        band.learningPaths = _.reject(band.learningPaths, { id: path.id });
                    }, function () {
                        messageService.error("common.genericError");
                    });
                }).catch(angular.noop);
            };
            //Reordering
            $document.on("keyup", function (e) {
                var newOrder;
                var nextCategory;
                if (!vm.reorderMode)
                    return;
                if (e.keyCode === 38) { //Arrow Up
                    if (vm.selectedCategory) {
                        newOrder = vm.selectedCategory.order - 1;
                        vm.placeCategoryAt(newOrder);
                    }
                    else if (vm.selectedBand) {
                        newOrder = vm.selectedBand.band.order - 1;
                        if (newOrder <= 0) {
                            nextCategory = _.find(vm.categories, { order: vm.selectedBand.category.order - 1 });
                            if (nextCategory)
                                vm.placeBandAt(nextCategory);
                        }
                        else {
                            vm.placeBandAt(vm.selectedBand.category, newOrder);
                        }
                    }
                    else if (vm.selectedPath) {
                        newOrder = vm.selectedPath.path.order - 1;
                        vm.placePathAt(vm.selectedPath.band, newOrder);
                    }
                }
                else if (e.keyCode === 40) { //Arrow Down
                    if (vm.selectedCategory) {
                        newOrder = vm.selectedCategory.order + 1;
                        vm.placeCategoryAt(newOrder);
                    }
                    else if (vm.selectedBand) {
                        newOrder = vm.selectedBand.band.order + 1;
                        if (newOrder > vm.selectedBand.category.bands.length) {
                            nextCategory = _.find(vm.categories, { order: vm.selectedBand.category.order + 1 });
                            if (nextCategory)
                                vm.placeBandAt(nextCategory, 1);
                        }
                        else {
                            vm.placeBandAt(vm.selectedBand.category, newOrder);
                        }
                    }
                    else if (vm.selectedPath) {
                        newOrder = vm.selectedPath.path.order + 1;
                        vm.placePathAt(vm.selectedPath.band, newOrder);
                    }
                }
                else if (e.keyCode === 13 || e.keyCode === 27) { //Enter or ESC
                    delete vm.selectedCategory;
                    delete vm.selectedBand;
                    delete vm.selectedPath;
                }
                $scope.$apply();
            });
            vm.setReorderType = function (type) {
                vm.reorderMode = true;
                vm.categorySortableOptions.disabled = true;
                vm.bandSortableOptions.disabled = true;
                vm.pathSortableOptions.disabled = true;
                delete vm.selectedCategory;
                delete vm.selectedBand;
                delete vm.selectedPath;
                switch (type) {
                    case 'category':
                        vm.categorySortableOptions.disabled = false;
                        break;
                    case 'band':
                        vm.bandSortableOptions.disabled = false;
                        break;
                    case 'path':
                        vm.pathSortableOptions.disabled = false;
                        break;
                }
                vm.reorderType = type;
            };
            vm.categorySortableOptions = {
                placeholder: "place-category-drag",
                connectWith: ".sortable-wrapper",
                axis: "y",
                cancel: ".place-category",
                disabled: true,
                start: function (_e, ui) {
                    vm.selectedCategory = ui.item.sortable.model;
                },
                stop: function (_e, ui) {
                    vm.placeCategoryAt(ui.item.sortable.dropindex + 1);
                    delete vm.selectedCategory;
                }
            };
            vm.reorderCategory = function (category) {
                if (!vm.reorderMode)
                    return;
                if (vm.reorderType !== 'category')
                    return;
                if (vm.selectedCategory === category) {
                    delete vm.selectedCategory;
                }
                else {
                    vm.selectedCategory = category;
                    $anchorScroll(category);
                }
            };
            vm.placeCategoryAt = function (order) {
                //Get the list without the item I'm moving
                var list = _.without(vm.categories, vm.selectedCategory);
                if (order < 1)
                    order = 1;
                list.splice(order - 1, 0, vm.selectedCategory);
                vm.categories = recalculateOrder(list);
            };
            vm.placeCategoryBefore = function (category) {
                //Get the list without the item I'm moving
                var list = _.without(vm.categories, vm.selectedCategory);
                //Insert at the end
                if (category === undefined) {
                    list.push(vm.selectedCategory);
                }
                else {
                    var index = _.indexOf(list, category);
                    list.splice(index, 0, vm.selectedCategory);
                }
                vm.categories = recalculateOrder(list);
                delete vm.selectedCategory;
            };
            //Bands
            vm.bandSortableOptions = {
                placeholder: "place-band-drag",
                connectWith: ".band-list",
                cancel: ".place-band",
                axis: "y",
                disabled: true,
                dropOnEmpty: true,
                start: function (_e, ui) {
                    vm.selectedBand = {
                        band: ui.item.sortable.model,
                        category: ui.item.parent().scope().category
                    };
                },
                stop: function (_e, ui) {
                    var category = ui.item.sortable.droptarget.parent().scope().category;
                    vm.placeBandAt(category, ui.item.sortable.dropindex + 1);
                    delete vm.selectedBand;
                }
            };
            vm.reorderBand = function (band, category) {
                if (!vm.reorderMode)
                    return;
                if (vm.reorderType !== 'band')
                    return;
                if (vm.selectedBand && vm.selectedBand.band === band) {
                    delete vm.selectedBand;
                }
                else {
                    vm.selectedBand = {
                        category: category,
                        band: band
                    };
                }
            };
            vm.placeBandAt = function (category, order) {
                if (category !== vm.selectedBand.category) {
                    var oldList = _.without(vm.selectedBand.category.bands, vm.selectedBand.band);
                    vm.selectedBand.category.bands = recalculateOrder(oldList);
                    vm.selectedBand.band.updated = true;
                    vm.selectedBand.band.categoryId = category.id;
                    vm.selectedBand.band.categoryNumber = category.number;
                    vm.selectedBand.category = category;
                }
                //Get the list without the item I'm moving
                var list = _.without(category.bands, vm.selectedBand.band);
                if (order === undefined) {
                    list.push(vm.selectedBand.band);
                }
                else {
                    if (order < 1)
                        order = 1;
                    list.splice(order - 1, 0, vm.selectedBand.band);
                }
                category.bands = recalculateOrder(list);
            };
            vm.placeBandBefore = function (category, band) {
                if (category !== vm.selectedBand.category) {
                    var oldList = _.without(vm.selectedBand.category.bands, vm.selectedBand.band);
                    vm.selectedBand.category.bands = recalculateOrder(oldList);
                    vm.selectedBand.band.updated = true;
                    vm.selectedBand.band.categoryId = category.id;
                    vm.selectedBand.band.categoryNumber = category.number;
                    vm.selectedBand.category = category;
                }
                //Get the list without the item I'm moving
                var list = _.without(category.bands, vm.selectedBand.band);
                //Insert at the end
                if (band === undefined) {
                    list.push(vm.selectedBand.band);
                }
                else {
                    var index = _.indexOf(list, band);
                    list.splice(index, 0, vm.selectedBand.band);
                }
                category.bands = recalculateOrder(list);
                delete vm.selectedBand;
            };
            //Paths
            vm.pathSortableOptions = {
                placeholder: "place-path-drag",
                connectWith: ".learning-path-list",
                axis: "y",
                cancel: ".place-path",
                disabled: true,
                dropOnEmpty: true,
                start: function (_e, ui) {
                    //console.log("pathSortableOptions.start");
                    var category = ui.item.parent().parent().scope().category;
                    if (category) {
                        var band = ui.item.parent().scope().band;
                        vm.selectedPath = {
                            category: category,
                            band: band,
                            path: ui.item.scope().path
                        };
                    }
                },
                stop: function (_e, ui) {
                    //console.log("pathSortableOptions.stop");
                    if (ui.item.sortable.droptarget) {
                        var band = ui.item.sortable.droptarget.scope().band;
                        vm.placePathAt(band, ui.item.sortable.dropindex + 1);
                    }
                    delete vm.selectedPath;
                }
            };
            vm.reorderPath = function (path, band, category) {
                if (!vm.reorderMode)
                    return;
                if (vm.reorderType !== 'path')
                    return;
                if (vm.selectedPath && vm.selectedPath.path === path) {
                    delete vm.selectedPath;
                }
                else {
                    vm.selectedPath = {
                        category: category,
                        band: band,
                        path: path
                    };
                }
            };
            vm.placePathAt = function (band, order) {
                if (band !== vm.selectedPath.band) {
                    var oldList = _.without(vm.selectedPath.band.learningPaths, vm.selectedPath.path);
                    vm.selectedPath.band.learningPaths = recalculateOrder(oldList);
                    vm.selectedPath.path.updated = true;
                    vm.selectedPath.path.bandId = band.id;
                    vm.selectedPath.path.bandNumber = band.number;
                    vm.selectedPath.band = band;
                }
                //Get the list without the item I'm moving
                var list = _.without(band.learningPaths, vm.selectedPath.path);
                if (order === undefined) {
                    list.push(vm.selectedPath.path);
                }
                else {
                    if (order < 1)
                        order = 1;
                    list.splice(order - 1, 0, vm.selectedPath.path);
                }
                //band.learningPaths = list;
                band.learningPaths = recalculateOrder(list);
            };
            vm.placePathBefore = function (band, path) {
                if (band !== vm.selectedPath.band) {
                    var oldList = _.without(vm.selectedPath.band.learningPaths, vm.selectedPath.path);
                    vm.selectedPath.band.learningPaths = recalculateOrder(oldList);
                    vm.selectedPath.path.updated = true;
                    vm.selectedPath.path.bandId = band.id;
                    vm.selectedPath.path.bandNumber = band.number;
                    vm.selectedPath.band = band;
                }
                //Get the list without the item I'm moving
                var list = _.without(band.learningPaths, vm.selectedPath.path);
                //Insert at the end
                if (path === undefined) {
                    list.push(vm.selectedPath.path);
                }
                else {
                    var index = _.indexOf(list, path);
                    list.splice(index, 0, vm.selectedPath.path);
                }
                band.learningPaths = recalculateOrder(list);
                delete vm.selectedPath;
            };
            vm.saveReorder = function () {
                if (vm.saving)
                    return;
                vm.saving = true;
                categoryResource.saveReorder({ categories: vm.categories }, function (result) {
                    vm.categories = result.categories;
                    vm.categories.sort(function (a, b) { return a.order - b.order; });
                    for (var category in vm.categories) {
                        if (vm.categories.hasOwnProperty(category)) {
                            vm.categories[category].bands.sort(function (a, b) { return a.order - b.order; });
                            for (var band in vm.categories[category].bands) {
                                if (vm.categories[category].bands.hasOwnProperty(band)) {
                                    vm.categories[category].bands[band].learningPaths.sort(function (a, b) { return a.order - b.order; });
                                }
                            }
                        }
                    }
                    vm.reorderMode = false;
                    vm.categorySortableOptions.disabled = true;
                    vm.bandSortableOptions.disabled = true;
                    vm.pathSortableOptions.disabled = true;
                    delete vm.selectedCategory;
                    delete vm.selectedBand;
                    delete vm.selectedPath;
                    vm.reorderType = "";
                    vm.saving = false;
                }, function (error) {
                    vm.saving = false;
                    messageService.error(error);
                });
            };
            vm.cancelReorder = function () {
                vm.reorderMode = false;
                vm.categorySortableOptions.disabled = true;
                vm.bandSortableOptions.disabled = true;
                vm.pathSortableOptions.disabled = true;
                delete vm.selectedCategory;
                delete vm.selectedBand;
                delete vm.selectedPath;
                vm.reorderType = "";
                //Undo changes
                loadCategories();
            };
            //Delete Category
            vm.deleteCategory = function (category) {
                var categoryNumber = category.number;
                var modal = $uibModal.open({
                    templateUrl: !_.some(category.bands, function (band) { return band.learningPaths.length > 0; }) ? "deleteWithoutPathsConfirmation.html" : "deleteWithPathsConfirmation.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    categoryResource.delete({ number: categoryNumber }, function () {
                        loadCategories();
                    }, function () {
                        messageService.error("common.genericError");
                    });
                }).catch(angular.noop);
            };
            //Delete Band
            vm.deleteBand = function (category, band) {
                var categoryNumber = category.number;
                var bandNumber = band.number;
                var modal = $uibModal.open({
                    templateUrl: band.learningPaths.length === 0 ? "deleteWithoutPathsConfirmation.html" : "deleteWithPathsConfirmation.html",
                    backdrop: false,
                    animation: false
                });
                modal.result.then(function () {
                    bandResource.delete({ categoryNumber: categoryNumber, number: bandNumber }, function () {
                        loadCategories();
                    }, function () {
                        messageService.error("common.genericError");
                    });
                }).catch(angular.noop);
            };
            function recalculateOrder(list) {
                return _.map(list, function (item, key) {
                    if (item.order !== key + 1) {
                        item.order = key + 1;
                        item.updated = true;
                    }
                    return item;
                });
            }
            function getNextName(listToCompare, name, maxLength) {
                var i = 0;
                var textToAppend = "";
                var item;
                do {
                    if (i > 0)
                        textToAppend = " (" + i + ")";
                    item = _.find(listToCompare, { name: name.toString().substring(0, maxLength - textToAppend.length) + textToAppend });
                    i++;
                } while (item !== undefined);
                return name.toString().substring(0, maxLength - textToAppend.length) + textToAppend;
            }
        }
    });
}());
